import {
  getIsSubscribedToPlus,
  getIsSubscribedToLite,
  getIsSubscribedToOffline
} from '@selectors/subscription';
import pushRoute from '@utils/pushRoute';

function redirectToPractice({
  store,
  goalUID,
  isServer,
  res,
  redirect,
  isMobile
}) {
  const goalDetails = store.getState().topologies.data[goalUID];
  const hasLiteSubsciption = getIsSubscribedToLite(goalUID)(store.getState());
  const hasSubscription = getIsSubscribedToPlus(goalUID)(store.getState());
  const isOfflineSubscription = getIsSubscribedToOffline(goalUID)(
    store.getState()
  );

  if (
    hasSubscription ||
    hasLiteSubsciption ||
    isOfflineSubscription ||
    redirect
  ) {
    if (isMobile) {
      return;
    }
    if (isServer) {
      res.writeHead(302, {
        location: `/goal/${goalDetails?.goalSlug || '-'}/${goalUID}/practice`
      });
      return res.end();
    }
    return pushRoute(
      '/goal/goalSlug/goalUID/practice',
      `/goal/${goalDetails?.goalSlug || '-'}/${goalUID}/practice`
    );
  }
}

export default redirectToPractice;
